module.exports = __webpack_public_path__ + "static/media/4_diagram_3.1dd61a27.svg";